<template>
  <footer class="footer" :class="{ 'footer-mobile': isMobile }">
    <div class="footer-content">
      <h2>{{ $t('footer.contacts') }}</h2>
      <div class="flex">
        <a href="tel:+38269904274">
          <img src="../assets/images/ico2.png" alt="">
        </a>
        <a href="tel:+38269904274">
          <img src="../assets/images/ico3.png" alt="">
        </a>
        <a href="tel:+38269904274">
          <img src="../assets/images/ico4.png" alt="">
        </a>
      </div>
      <a href="tel:+38269904274">
        +382 69 904 274
      </a>
      <a href="tel:+381644132343">
        +381 64 413 23 43
      </a>
    </div>
    <div class="footer-bottom" id="contact">
      <div class="pwd-by">Web Design by <a href="https://exacta.agency/"><b> exacta.agency</b></a></div>
    </div>
  </footer>
</template>

<script>

export default {
  name: 'Footer-component',

  data() {
    return {
      isMobile: false
    }
  },
  created() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 1159;
    },
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/main.scss";

.footer {
  background-color: $darker-blue;
  color: #fff;
  padding: 50px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .footer-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 70%;
    width: 100%;

    h2 {
      font-size: 60px;
      text-transform: uppercase;
      font-weight: bold;
      margin: 20px;
    }

    a {
      color: #FFFFFF;
      font-family: Inter, sans-serif;
      font-weight: 600;
      font-size: 40px;
      text-decoration: none;
      text-transform: uppercase;

      &:hover {
        color: $primary-blue;

      }
    }

    .flex {
      display: flex;
      justify-content: space-evenly;
      align-items: center;

      img {
        max-width: 25px;
        margin: 10px;
      }
    }
  }

  .footer-bottom {
    width: 70%;
    margin-top: 20px;
    border-top: 1px solid #444;
    padding-top: 10px;
    @media (max-width: 1599px) {
      width: 85%;
    }
    @media (max-width: 1599px) {
      width: 85%;
    }

    .pwd-by {
      color: white;
      cursor: pointer;
      height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;

      b {
        padding-left: 3px;
        transition: color 0.7s ease-in-out;
      }

      &:hover {
        b {
          color: $primary-blue;
        }
      }

      a {
        color: white;
        text-decoration: none;
      }
    }
  }
}

.footer-mobile {
  padding: 0 0 250px!important;
  gap: 0;
  .footer-content {
    h2 {
      font-size: 30px !important;
    }
    a {
      font-size: 20px !important;
    }
  }
  .footer-bottom {
    width: 70%;
    margin-top: 20px;
    border-top: 1px solid #444;
    padding-top: 10px;

    @media (max-width: 1599px) {
      width: 85%;
    }
    @media (max-width: 1599px) {
      width: 85%;
    }
  }
}
</style>
